<template>
  <div class="game-import-form d-flex">
    <v-icon
      v-if="isImporting"
      icon="download"
      title="Download CSV example"
      @click="onDownloadSampleClick"
    >mdi-download</v-icon>
    <v-file-input
      v-if="isImporting"
      v-model="file"
      accept=".csv"
      class="game-import-form-file"
      dense
      hide-details
      :disabled="isLoading"
      :loading="isLoading"
    />

    <v-icon
      v-if="!isImporting"
      title="Import"
      :disabled="isLoading"
      @click="isImporting = true"
    >mdi-arrow-expand-up</v-icon>
    <v-icon
      v-if="isImporting"
      title="Confirm"
      :disabled="!file || isLoading || importRequested"
      @click="onImportClick"
    >check</v-icon>
    <v-icon
      v-if="isImporting"
      title="Cancel"
      :disabled="isLoading"
      @click="isImporting = false, file = null"
    >
      cancel
    </v-icon>
  </div>
</template>

<script>
const SAMPLE_CSV = `name,system,brand,external_id,code,code_mobile,code_external,code_mobile_external,data,allow_freespins,type,enabled,bonus_no_play
dummy,pragmatic,skillzz,dummy_external_id,123,1234,12345,123456,"{""data_field"": ""data_field_value""}",1,slots,1,0`;

export default {
  props: {
    isLoading: Boolean,
  },
  data() {
    return {
      file: null,
      isImporting: false,
      importRequested: false,
    }
  },
  methods: {
    onImportClick() {
      this.importRequested = true;
      const reader = new FileReader();
      reader.readAsText(this.file, 'utf-8');
      reader.addEventListener('load', e => {
        this.$emit('import', e.target.result);
      });
    },

    onDownloadSampleClick() {
      var blob = new Blob([SAMPLE_CSV], {type: 'application/octet-stream'});
      const blobURL = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', 'game_import_sample.csv');

      document.body.appendChild(tempLink);
      tempLink.click();

      tempLink.remove();
      window.URL.revokeObjectURL(blobURL);
    }
  },

  watch: {
    isLoading(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.isImporting = false;
        this.importRequested = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.game-import-form {
  &-file {
    margin: 0 0.5rem;
    width: 15rem;
  }
}
</style>
